import { BrowserView, MobileView } from 'react-device-detect';
import IJobDetail, { JobMember } from '@th-types/job.detail.type';
import { IJobStatsList } from '@th-types/jobs.type';
import { JobTableItemDesktop } from './JobTableItemDesktop';
import JobTableMobile from './JobTableMobile/JobTableMobile';

interface Props {
  jobList: IJobDetail[];
  jobStatsList: IJobStatsList;
  hideJob: (job: IJobDetail) => void;
  showJobMembers: (members: JobMember[]) => void;
  handleOpenModalShareJobLink: (job: IJobDetail) => void;
}

export default function JobTable({
  jobList,
  jobStatsList,
  hideJob,
  showJobMembers,
  handleOpenModalShareJobLink,
}: Props) {
  return (
    <div className="pt-2" data-testid="job-table">
      <MobileView>
        <JobTableMobile
          hideJob={hideJob}
          showJobMembers={showJobMembers}
          handleOpenModalShareJobLink={handleOpenModalShareJobLink}
          jobList={jobList}
          jobStatsList={jobStatsList}
        />
      </MobileView>
      <BrowserView>
        <div className="px-4">
          {jobList.map((job) => (
            <div className="mb-2" key={job.id}>
              <JobTableItemDesktop
                key={job.id}
                job={job}
                hideJob={hideJob}
                showJobMembers={showJobMembers}
                jobStats={jobStatsList.results.find(
                  (jobItem) => jobItem.jobId === job.id
                )}
                handleOpenModalShareJobLink={handleOpenModalShareJobLink}
              />
            </div>
          ))}
        </div>
      </BrowserView>
    </div>
  );
}
